import { useState, useEffect } from "react";
import TopUsersMini from "./TopUsersMini";
import UniversitySupport from "./UniversitySupport";
import { useTranslation } from "react-i18next";

const FACE =
    "absolute inset-0 rounded-[3vh] bg-white shadow-[0_0.5vh_2vh_rgba(18,22,31,0.08)] overflow-hidden";

function TopSocialFlipCard({ compact = false }) {
    const { t } = useTranslation();
    const [flipped, setFlipped] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => setFlipped((f) => !f), 30000);
        return () => clearInterval(timer);
    }, []);

    return (
        <button
            type="button"
            data-testid="top-support-flip"
            aria-label={t("routeList.flip_support")}
            className="w-full h-full cursor-pointer text-left rounded-[3vh] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#246CE2]"
            style={{ perspective: "200vh" }}
            onClick={() => setFlipped((f) => !f)}
        >
            <div
                data-testid="top-support-faces"
                className="relative w-full h-full transition-transform duration-700"
                style={{
                    transformStyle: "preserve-3d",
                    transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
                }}
            >
                <div className={FACE} style={{ backfaceVisibility: "hidden" }}>
                    <TopUsersMini compact={compact} />
                </div>
                <div
                    className={FACE}
                    style={{
                        backfaceVisibility: "hidden",
                        transform: "rotateY(180deg)",
                    }}
                >
                    <UniversitySupport compact={compact} />
                </div>
            </div>
        </button>
    );
}

export default TopSocialFlipCard;
